import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-comprehensive-request-stepper',
  templateUrl: './comprehensive-request-stepper.component.html',
  styleUrls: ['./comprehensive-request-stepper.component.css']
})
export class ComprehensiveRequestStepperComponent implements OnInit {

  @Input() comprehensiveRequestStatus : number;
  @Input() comprehensiveRequestOwnerName : string;
  constructor() { }

  ngOnInit() {
  }

}
